import {EventListener, EventVerteiler} from "../../global/eventVerteiler";
import {ChromoLogoColor, StockLogo} from "../selectableObjects";
import {ShaderCreator} from "../shader/OwayoShader";
import {PatternInEntwurf} from "../pattern/patternEntwurfsobjektInteractor";
import {StocklogoController} from "../stocklogos/stocklogoController";
import {OwayoJSKonfiViewer} from "../owayoJSViewerWithSelObs";
import {PartPatternContainer} from "../pattern/partPatternContainer";
import {PATTERN_EVENTNAMES} from "../pattern/patternFactory";
import {StockLogoPoolEntry} from "../stocklogos/stocklogoController";
import {PartPattern} from "../pattern/partPattern";
import globalsObject from "../globalsObject";
import {StockLogoColorVersionColor} from "../pattern/patternFarbVorschlaege";
import {HistoryStepFactory} from "../history/historyStepFactory";

export class PatternFarbGedaechtnisContainer {
    private brain:Patternfarbgedaechtnis[] = [];

    public getFarbgedaechtnisForColorCode(colorCode:string):Patternfarbgedaechtnis|null {
        const filtered = this.brain.filter((g:Patternfarbgedaechtnis)=>g.forColorCode === colorCode);
        return filtered.length > 0 ? filtered[0] : null;
    }

    private setNewFarbgedaechtnis(forColorCodeNr, colors) {
        const gedaechtnis = new Patternfarbgedaechtnis(globalsObject.controller.getColorCodeFromColorCodeNr(forColorCodeNr));
        colors.forEach((c)=>gedaechtnis.colorIntValuesOrderedByfarbnummerNachFarbAnteil[c.farbnummerNachFarbanteil-1] = c.colorIntValue);
        this.deleteFarbGedaechntisForColorCode(globalsObject.controller.getColorCodeFromColorCodeNr(forColorCodeNr));
        this.brain.push(gedaechtnis);
    }

    public deleteFarbGedaechntisForColorCode(colorCode) {
        this.brain = this.brain.filter(g=>g.forColorCode !== colorCode);
    }

    public updateOrCreateFarbGedaechtnis(forColorCodeNr, colors) {
        const bestehend = this.getFarbgedaechtnisForColorCode(globalsObject.controller.getColorCodeFromColorCodeNr(forColorCodeNr));
        if(bestehend !== null) {
            colors.forEach(c=>{
                bestehend.colorIntValuesOrderedByfarbnummerNachFarbAnteil[c.farbnummerNachFarbanteil-1] = c.colorIntValue;
            });
        } else {
            this.setNewFarbgedaechtnis(forColorCodeNr, colors);
        }
    }

    public clear() {
        this.brain = [];
    }
}

export class Patternfarbgedaechtnis {
    public forColorCode:string;
    public colorIntValuesOrderedByfarbnummerNachFarbAnteil:number[]= [];
    public vorbelegung=[];

    constructor(forColorCode) {
        this.forColorCode = forColorCode;
    }

    public customColorsEqualVorbelegung() {
        const obergrenze = Math.min(this.vorbelegung.length, this.colorIntValuesOrderedByfarbnummerNachFarbAnteil.length)
        for(let i=0; i < obergrenze; i++) {
            if(this.vorbelegung[i] !== this.colorIntValuesOrderedByfarbnummerNachFarbAnteil[i]) {
                return false;
            }
        }
        return true;
    }
    //
    // public shouldShowButton() {
    //     return !this.customColorsEqualVorbelegung()
    // }
}

export class PartPatternController extends EventListener{
    private viewer: OwayoJSKonfiViewer;
    private patternContainer: PartPatternContainer[] = [];
    private farbgedaechtnis:PatternFarbGedaechtnisContainer;

    public constructor(viewer: OwayoJSKonfiViewer) {
        super();
        this.viewer = viewer;
        this.farbgedaechtnis = new PatternFarbGedaechtnisContainer();

        this.addEventListener(PATTERN_EVENTNAMES.CREATED, (data:{stockLogo: StockLogo}) => this.insertPattern(data.stockLogo))
            .addEventListener(PATTERN_EVENTNAMES.DELETED, (data) => this.deletePattern(data.colorCodeNr))
            .addEventListener(PATTERN_EVENTNAMES.REQUEST_COLOR_CHANGE, (data: { colorCodeOnEntwurf: string, colorCodeInPattern, newColorHexValue, oldColorHexValue, ignoreInHistory:boolean}) =>
                this.changePatternColor(data.colorCodeOnEntwurf, data.colorCodeInPattern, data.newColorHexValue, data.ignoreInHistory))
            .addEventListener(PATTERN_EVENTNAMES.CHANGESIZEUP_REQUEST,
                (data) => this.changePatternSize(data.colorCodeNr, "plus", data.callback))
            .addEventListener(PATTERN_EVENTNAMES.CHANGESIZEDOWN_REQUEST,
                (data) => this.changePatternSize(data.colorCodeNr, "minus", data.callback))
            .addEventListener(PATTERN_EVENTNAMES.CHANGESIZETOSTEP_REQUEST,
                (data) => this.changePatternSizeToStepNr(data.colorCodeNr, data.stepNr))
            .addEventListener(PATTERN_EVENTNAMES.FILLPATTERNSTEPSIZE, (data)=>this.fillPatternStepSize(data.forColorCode, data.callback))
            .addEventListener("loadSavedEntwurfEvent", ()=>this.reset())
            .addEventListener(PATTERN_EVENTNAMES.COLORVERSION_CLICKED, (data)=>this.colorversionClicked(data))

        ;
    }

    private reset() {
        this.farbgedaechtnis.clear();
        this.patternContainer = [];
    }

    private insertPattern(stockLogo: StockLogo) {
        this.deletePattern(stockLogo.clampToColor);
        this.createPartPatternContainer(stockLogo);
        const container = this.patternContainer.filter(c=>c.forColorCodeNr === stockLogo.clampToColor)[0];
        this.farbgedaechtnis.updateOrCreateFarbGedaechtnis(container.forColorCodeNr, container.colors);
        // falls es schon existiert kann es sein, dass Farben, die über das bisherige Farbgedaechtnis hinausgehen hinzugefügt werden müssen
    }

    public getPatterns(partname: string) {
        return this.patternContainer.reduce(
            function (carry, c) {
                carry = carry.concat(c.getPatterns(partname));
                return carry;
            }, [] as PartPattern[]);
    }

    private createPartPatternContainer(stockLogo: StockLogo) {
        this.patternContainer.push(new PartPatternContainer(stockLogo, () => this.viewer.getDroppableParts()));
    }

    clear() {
        this.patternContainer = [];
    }

    private deletePattern(colorCodeNr: number) {
        this.patternContainer = this.patternContainer.filter(c => c.forColorCodeNr !== colorCodeNr);
        this.viewer.getDroppableParts().forEach(p => ShaderCreator.createShaders(p, this.getPatterns(p.name)));
    }

    private changePatternColor(colorCodeOnEntwurf: string, colorCodeInPattern: string, colorValue: string, ignoreInHistory = false) {
        const colorCodeNr = globalsObject.controller.getColorCodeNr(colorCodeOnEntwurf);
        const aliasesPlusColorCode = globalsObject.controller.getColorCodeNumbersOfAliases(globalsObject.controller.getColorCodeNr(colorCodeOnEntwurf)).concat([colorCodeNr]);
        const containers = this.patternContainer.filter(c => aliasesPlusColorCode.indexOf(c.forColorCodeNr)>-1);
        containers.forEach(container=> {
            const oldColorHex = container.getColorHexValue(colorCodeInPattern);
        container.setColorValue(colorCodeInPattern, colorValue);
        this.farbgedaechtnis.updateOrCreateFarbGedaechtnis(container.forColorCodeNr, container.colors);
        EventVerteiler.broadcast(PATTERN_EVENTNAMES.COLOR_CHANGED, {
                colorCodeOnEntwurf: globalsObject.controller.getColorCodeFromColorCodeNr(container.forColorCodeNr),
                colorCodeInPattern: colorCodeInPattern,
                newColorHex: colorValue,
                oldColorHex: oldColorHex,
                ignoreInHistory: ignoreInHistory
        });
        container.broadcastPreviewSVG();
        });
    }

    public changePatternColorsToFarbGedaechtnis(colorCodeNrOnEntwurf:number, farbGedaechtnis:Patternfarbgedaechtnis) {
        const container = this.patternContainer.filter(c => c.forColorCodeNr === colorCodeNrOnEntwurf)[0];
        container.setColorValueFromFarbGedaechtnis(farbGedaechtnis);
        container.broadcastPreviewSVG();
    }

    private changePatternSize(colorCodeNrOnDraft: number, direction: "plus" | "minus", callback) {
        this.patternContainer.filter(c => c.forColorCodeNr === colorCodeNrOnDraft)
            .forEach(c=>c.changeInsertTargetSizeInDirection(direction));
        this.fillPatternStepSize(colorCodeNrOnDraft, callback)
    }
    private changePatternSizeToStepNr(colorCodeNrOnDraft, stepNr) {
        this.patternContainer.filter(c=>c.forColorCodeNr === colorCodeNrOnDraft)
            .forEach(c=>c.changeInserttargetSizeToStepNr(stepNr))
    }


    private fillPatternStepSize(forColorCode, callback) {
        const container = this.patternContainer.filter(c => c.forColorCodeNr === forColorCode)[0];
        if(typeof(callback)!=="undefined"){callback(container.getSizeStepNumber())}
    }

    public getPatternContainerForColorCodeNr(colorCodeNr) :PartPatternContainer|null{
        const out =  this.patternContainer.filter(c => c.forColorCodeNr === colorCodeNr);
        return out.length>0 ? out[0] : null;
    }

    insertPatternsAfterProductChange(patterns: PatternInEntwurf[]) {
        if(!StocklogoController.patternsFreigeschaltetFuerProdukt()) {
            return;
        }
        const toBroadcast = patterns.filter((pattern: PatternInEntwurf) => globalsObject.controller.colorToDisplayIsVisible(pattern.forColorCode))
        EventVerteiler.broadcast(PATTERN_EVENTNAMES.LOADED, {patterns:toBroadcast});
    }

    private static sendMainColorChange(colorCode, colorHexValue) {
        EventVerteiler.broadcast(
            "colorChangedEvent",
            {
                colorHexValue : colorHexValue,
                colorCode : colorCode,
                byUser:"no"
            }
        );
    }

    private colorversionClicked(data: {forColorCodeNr, colorversionID, stockLogoID }) {
        const logo = StocklogoController.getLogo(data.stockLogoID) as StockLogoPoolEntry;

        const farbkombiArray = logo.colorVersions.filter(e=>e.id === data.colorversionID);
        if(farbkombiArray.length === 0) {
            return;
        }
        const colorCodeInPattern = logo.colors.find(c=>c.farbnummerNachFarbanteil === 1)?.colorCode

        const container = this.getPatternContainerForColorCodeNr(data.forColorCodeNr) as PartPatternContainer;
        const oldcolors = container.colors.map(c=>ChromoLogoColor.clone(c));
        this.executePatternColorChangeInBulk(data.forColorCodeNr, farbkombiArray[0].colors, colorCodeInPattern)
        const newColors = container.colors.map(c=>ChromoLogoColor.clone(c));
        EventVerteiler.broadcast("showMyColorsButtonEvent");
        HistoryStepFactory.addHistoryStep("patternColorVersionClicked",
            ()=>{
                this.executePatternColorChangeInBulk(data.forColorCodeNr, oldcolors, colorCodeInPattern);
                EventVerteiler.broadcast("hideMyColorsButtonEvent");
                /** Der Button "mycolors" muss ausgeblendet werden, wenn das der letzte PatterncolorChangeStep in der History für dieses pattern ist. Also colorcode und pattern!
                 * Weiter wirds kompliziert, weil er das Pattern gelöscht und wieder hinzugefügt haben könnte, dann wäre ein HistoryStep in der History der aber nicht rechtfertigt, den Button anzuzeigen
                 * wurgs
                 * */
            },
            ()=>{
            this.executePatternColorChangeInBulk(data.forColorCodeNr, newColors, colorCodeInPattern);
                EventVerteiler.broadcast("showMyColorsButtonEvent");
                /** Hier ist das Problem mit dem doofen Button ähnlich, aber wahrscheinlich ok.
                 * */
            }
        );
    }

    private executePatternColorChangeInBulk(colorCodeNumber:number, colors:StockLogoColorVersionColor[], mainColorCodeInPattern) {
        const container = this.getPatternContainerForColorCodeNr(colorCodeNumber) as PartPatternContainer;
        const colorCodeFromColorCodeNr = globalsObject.controller.getColorCodeFromColorCodeNr(colorCodeNumber);
        container.setColorsToColorVersion(colors)
        PartPatternController.sendMainColorChange(
            colorCodeFromColorCodeNr,
            container.getColorHexValue(mainColorCodeInPattern)
        );
        container.broadcastPreviewSVG();
        EventVerteiler.broadcast("setColorPickerBackgroundColorToPatternColorsWithoutInitEvent", {forColorCodeNr:colorCodeNumber, colors: container.colors})
    }

    public broadCastAllPreviewSVGs() {
        this.patternContainer.forEach(c=>c.broadcastPreviewSVG());
    }
}
